import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormNames } from 'src/app/models/enums/quote-form-names';
import { HouseholdQuoteStateService } from '../../household-quote-state-service/household-quote-state.service';
import { ContentsCalculatorRooms } from 'src/app/models/enums/contents-calculator-rooms';

@Injectable({
    providedIn: 'root'
})
export class ContentsCalcFormBuilderService {

    private editContentCover: boolean = false;

    constructor(private formBuilder: FormBuilder,
        private householdQuoteStateService: HouseholdQuoteStateService) { }

    public getContentsCalcQuoteForm(refresh: Boolean = false): FormGroup<any> {
        let result;
        if (!refresh && this.householdQuoteStateService.hasFormState(FormNames.contentsCalcForm)) {
            result = this.householdQuoteStateService.getFormState(FormNames.contentsCalcForm).form;
        }
        else {
            result = this.formBuilder.group({
                rooms: this.formBuilder.array([]),
                totalValue: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            });
            (result.controls.rooms as FormArray).push(this.getSittingRoomFormGroup());
            (result.controls.rooms as FormArray).push(this.getDiningRoomFormGroup());
            (result.controls.rooms as FormArray).push(this.getKitchenRoomFormGroup());
            (result.controls.rooms as FormArray).push(this.getBedroomsRoomFormGroup());
            (result.controls.rooms as FormArray).push(this.getBathroomsFormGroup());
            (result.controls.rooms as FormArray).push(this.getGardenFormGroup());
            (result.controls.rooms as FormArray).push(this.getExtraRoomFormGroup());
            (result.controls.rooms as FormArray).push(this.getAtticFormGroup());
        }
        this.householdQuoteStateService.setFormState(result, FormNames.contentsCalcForm);

        return result;
    }

    private getSittingRoomFormGroup(): FormGroup<any> {
        return this.formBuilder.group({
            roomElements: this.formBuilder.group({
                books: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                CDsVinyl: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                DVDsVideos: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                carpetsFloor: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                computerEquipmentSoftware: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                curtainsBlinds: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                electrical: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                furniture: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                gamesConsoles: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                hifiEquipmentStereos: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                mirror: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                ornaments: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                picturesArt: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                satelleiteReceiver: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                silver: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                TvVideoDVDplayer: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                other: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),

            }),
            title: this.formBuilder.control({ value: ContentsCalculatorRooms.sittingRoom, disabled: false }, { updateOn: 'change' }),
            editMode: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            subtotal: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
        })
    }

    private getDiningRoomFormGroup(): FormGroup<any> {
        return this.formBuilder.group({
            roomElements: this.formBuilder.group({
                carpetsCurtains: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                dining: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                furniture: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                lamps: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                linen: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                wines: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                other: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            }),
            title: this.formBuilder.control({ value: ContentsCalculatorRooms.diningRoom, disabled: false }, { updateOn: 'change' }),
            editMode: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            subtotal: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
        })
    }
    private getKitchenRoomFormGroup(): FormGroup<any> {
        return this.formBuilder.group({
            roomElements: this.formBuilder.group({
                CarpetsCurtains: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                CookerOven: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                Dishwasher: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                CupboardContents: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                FreezerContents: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                FridgeFreezer: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                Furniture: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                Kitchenware: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                LargeElectrical: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                SmallElectrical: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                WashingMachine: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                other: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),

            }),
            title: this.formBuilder.control({ value: ContentsCalculatorRooms.kitchen, disabled: false }, { updateOn: 'change' }),
            editMode: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            subtotal: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
        })
    }

    private getBedroomsRoomFormGroup(): FormGroup<any> {
        return this.formBuilder.group({
            roomElements: this.formBuilder.group({
                BedLinen: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                CarpetsCoverings: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                ClothesShoes: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                CurtainsBlinds: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                Electrical: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                Furniture: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                ToysGames: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                other: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            }),
            title: this.formBuilder.control({ value: ContentsCalculatorRooms.bedrooms, disabled: false }, { updateOn: 'change' }),
            editMode: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            subtotal: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
        })
    }

    private getBathroomsFormGroup(): FormGroup<any> {
        return this.formBuilder.group({
            roomElements: this.formBuilder.group({
                CarpetsCoverings: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                CurtainsBlinds: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                Furniture: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                ShaverHairdryer: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                other: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            }),
            title: this.formBuilder.control({ value: ContentsCalculatorRooms.bathrooms, disabled: false }, { updateOn: 'change' }),
            editMode: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            subtotal: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
        })
    }

    private getExtraRoomFormGroup(): FormGroup<any> {
        return this.formBuilder.group({
            roomElements: this.formBuilder.group({
                equipment: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                carpets: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                curtainsBlinds: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                furniture: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                appliances: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                other: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            }),
            title: this.formBuilder.control({ value: ContentsCalculatorRooms.extraRoom, disabled: false }, { updateOn: 'change' }),
            editMode: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            subtotal: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
        })
    }

    private getGardenFormGroup(): FormGroup<any> {
        return this.formBuilder.group({
            roomElements: this.formBuilder.group({
                equipment: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                furniture: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                ornaments: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                play: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                sheds: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                machinery: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
                other: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            }),
            title: this.formBuilder.control({ value: ContentsCalculatorRooms.garden, disabled: false }, { updateOn: 'change' }),
            editMode: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            subtotal: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
        })
    }

    private getAtticFormGroup(): FormGroup<any> {
        return this.formBuilder.group({
            roomElements: this.formBuilder.group({
                miscellaneous: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            }),
            title: this.formBuilder.control({ value: ContentsCalculatorRooms.attic, disabled: false }, { updateOn: 'change' }),
            editMode: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
            subtotal: this.formBuilder.control({ value: null, disabled: false }, { updateOn: 'change' }),
        })
    }

    public setEditContentCover(setEdit: boolean) {
        this.editContentCover = setEdit;
    }

    public getEditContentCover() {
        return this.editContentCover;
    }
}
